module.exports = "/public/images/3ce339c2b0cfe2923299a5ee105e5421.png";